<template>
<div>
    <van-nav-bar
            title="我要提现"
            left-text="返回"
            left-arrow
            @click-left="onClickLeft"
    />
    <div class="title">可提现金额</div>
    <div class="money"><span style="font-size: 16px;font-weight: normal;">&yen;</span>&nbsp;{{commission.remain}}</div>
    <input class="input" type="input" v-model="money" placeholder="填写提现金额"/>
    <div class="type">选择提现方式</div>
    <div class="list">
        <div class="list-item-box" v-if="withdrawTypes.withdrawAli==1" @click="type='alipay'">
        <div class="list-item alipay"  :class="type=='alipay' ? 'active':''">
            <svg t="1607483330916" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3102" width="200" height="200"><path d="M991.67 689.448v-472.296c0-101.81-82.623-184.433-184.493-184.433h-590.414c-101.81 0-184.433 82.623-184.433 184.433v590.414c0 101.81 82.563 184.433 184.433 184.433h590.414c90.717 0 166.206-65.595 181.615-151.876-48.926-21.165-260.941-112.722-371.385-165.427-84.062 101.81-172.082 162.908-304.771 162.908s-221.248-81.724-210.636-181.735c7.015-65.655 52.044-172.981 247.629-154.574 103.069 9.653 150.257 28.9 234.319 56.661 21.765-39.873 39.813-83.763 53.543-130.47h-372.764v-36.935h184.433v-66.314h-224.965v-40.652h224.965v-95.694c0 0 2.039-14.99 18.587-14.99h92.216v110.684h239.835v40.652h-239.835v66.314h195.646c-17.988 73.209-45.269 140.483-79.446 199.243 56.841 20.566 315.503 99.652 315.503 99.652v0 0zM297.947 774.29c-140.183 0-162.368-88.499-154.933-125.494 7.375-36.815 47.967-84.842 125.914-84.842 89.578 0 169.803 22.904 266.097 69.792-67.633 88.079-150.736 140.543-237.077 140.543v0z" p-id="3103" fill="#1296db"></path></svg>
            <span v-if="account.aliAccount && account.aliAccount">***{{account.aliAccount.substr(-4)}}</span>
            <div class="svg">
                <svg t="1607484849593" class="icon" viewBox="0 0 1503 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6449" width="200" height="200"><path d="M433.191281 773.772335H989.244309c20.292532 0 36.744447-16.448112 36.744447-36.738743v-530.955921L433.191281 773.772335z m522.639652-215.384515l-124.1128 124.103294a13.373716 13.373716 0 0 1-19.014861 0l-18.99775-19.014862-62.911983-61.010687c-7.937911-7.93601-7.937911-20.672791 0-28.591689s20.672791-7.918898 28.59359 0l53.316143 51.414846a13.373716 13.373716 0 0 0 19.014861 0l95.502098-95.513506c7.937911-7.953121 20.672791-7.916997 28.610702 0.017112a20.148034 20.148034 0 0 1 0 28.595492z" p-id="6450" fill="#1296db"></path></svg>
            </div>
        </div>
        </div>
      <div class="list-item-box" v-if="withdrawTypes.withdrawWechat==1"  @click="type='wechat'">
        <div class="list-item wechat"  :class="type=='wechat' ? 'active':''">
            <svg t="1607483365538" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4100" width="200" height="200"><path d="M390.21952 631.09248c-61.26464 34.01984-70.35136-19.09888-70.35136-19.09888l-76.78208-178.46656c-29.54368-84.80512 25.56928-38.23744 25.56928-38.23744s47.2896 35.63392 83.17952 57.34784c35.87072 21.71392 76.75776 6.3744 76.75776 6.3744l501.9648-230.7776C837.94688 113.4528 684.96256 38.4 511.76576 38.4 229.11104 38.4 0 238.13248 0 484.52864c0 141.72544 75.8656 267.8656 194.0352 349.62176l-21.31072 122.01856c0 0-10.38848 35.6224 25.61536 19.10016 24.53376-11.26528 87.0784-51.63392 124.30976-76.20224 58.53056 20.31616 122.2976 31.5968 189.14432 31.5968 282.63168 0 511.79008-199.73248 511.79008-446.13376 0-71.36896-19.31008-138.76864-53.51552-198.59456C810.14144 381.7792 438.15808 604.51712 390.21952 631.09248L390.21952 631.09248 390.21952 631.09248zM390.21952 631.09248" p-id="4101" fill="#3ce17b"></path></svg>
            <span v-if="account.truename">*{{account.truename.substr(1)}}</span>
            <div class="svg">
            <svg t="1607484849593" class="icon" viewBox="0 0 1503 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6449" width="200" height="200"><path d="M433.191281 773.772335H989.244309c20.292532 0 36.744447-16.448112 36.744447-36.738743v-530.955921L433.191281 773.772335z m522.639652-215.384515l-124.1128 124.103294a13.373716 13.373716 0 0 1-19.014861 0l-18.99775-19.014862-62.911983-61.010687c-7.937911-7.93601-7.937911-20.672791 0-28.591689s20.672791-7.918898 28.59359 0l53.316143 51.414846a13.373716 13.373716 0 0 0 19.014861 0l95.502098-95.513506c7.937911-7.953121 20.672791-7.916997 28.610702 0.017112a20.148034 20.148034 0 0 1 0 28.595492z" p-id="6450" fill="#3ce17b"></path></svg>
            </div>
        </div>
      </div>
      <div class="list-item-box" v-if="withdrawTypes.withdrawWechatNew==1"  @click="type='wechatNew'">
        <div class="list-item wechat"  :class="type=='wechatNew' ? 'active':''">
            <svg t="1607483365538" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4100" width="200" height="200"><path d="M390.21952 631.09248c-61.26464 34.01984-70.35136-19.09888-70.35136-19.09888l-76.78208-178.46656c-29.54368-84.80512 25.56928-38.23744 25.56928-38.23744s47.2896 35.63392 83.17952 57.34784c35.87072 21.71392 76.75776 6.3744 76.75776 6.3744l501.9648-230.7776C837.94688 113.4528 684.96256 38.4 511.76576 38.4 229.11104 38.4 0 238.13248 0 484.52864c0 141.72544 75.8656 267.8656 194.0352 349.62176l-21.31072 122.01856c0 0-10.38848 35.6224 25.61536 19.10016 24.53376-11.26528 87.0784-51.63392 124.30976-76.20224 58.53056 20.31616 122.2976 31.5968 189.14432 31.5968 282.63168 0 511.79008-199.73248 511.79008-446.13376 0-71.36896-19.31008-138.76864-53.51552-198.59456C810.14144 381.7792 438.15808 604.51712 390.21952 631.09248L390.21952 631.09248 390.21952 631.09248zM390.21952 631.09248" p-id="4101" fill="#3ce17b"></path></svg>
            <span v-if="account.truename">*{{account.truename.substr(1)}}</span>
            <span style="font-size:11px;">新版</span>
            <div class="svg">
            <svg t="1607484849593" class="icon" viewBox="0 0 1503 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6449" width="200" height="200"><path d="M433.191281 773.772335H989.244309c20.292532 0 36.744447-16.448112 36.744447-36.738743v-530.955921L433.191281 773.772335z m522.639652-215.384515l-124.1128 124.103294a13.373716 13.373716 0 0 1-19.014861 0l-18.99775-19.014862-62.911983-61.010687c-7.937911-7.93601-7.937911-20.672791 0-28.591689s20.672791-7.918898 28.59359 0l53.316143 51.414846a13.373716 13.373716 0 0 0 19.014861 0l95.502098-95.513506c7.937911-7.953121 20.672791-7.916997 28.610702 0.017112a20.148034 20.148034 0 0 1 0 28.595492z" p-id="6450" fill="#3ce17b"></path></svg>
            </div>
        </div>
      </div>
      <div class="list-item-box" v-if="withdrawTypes.withdrawBank==1"   @click="type='bank'">
        <div class="list-item bank" :class="type=='bank' ? 'active':''">
          <svg t="1675150538552" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5256" width="128" height="128"><path d="M846.367347 820.244898H177.632653c-45.97551 0-83.591837-37.616327-83.591837-83.591837V287.346939c0-45.97551 37.616327-83.591837 83.591837-83.591837h668.734694c45.97551 0 83.591837 37.616327 83.591837 83.591837v449.306122c0 45.97551-37.616327 83.591837-83.591837 83.591837zM177.632653 245.55102c-22.987755 0-41.795918 18.808163-41.795918 41.795919v449.306122c0 22.987755 18.808163 41.795918 41.795918 41.795919h668.734694c22.987755 0 41.795918-18.808163 41.795918-41.795919V287.346939c0-22.987755-18.808163-41.795918-41.795918-41.795919H177.632653z" fill="#c23813" p-id="5257"></path><path d="M114.938776 339.591837h794.122448v94.040816H114.938776z" fill="#c23813" p-id="5258"></path><path d="M219.428571 709.485714c-11.493878 0-20.897959-9.404082-20.897959-20.897959v-156.734694c0-11.493878 9.404082-20.897959 20.897959-20.897959s20.897959 9.404082 20.89796 20.897959v156.734694c0 11.493878-9.404082 20.897959-20.89796 20.897959z" fill="#c23813" p-id="5259"></path><path d="M323.918367 709.485714c-11.493878 0-20.897959-9.404082-20.897959-20.897959v-156.734694c0-11.493878 9.404082-20.897959 20.897959-20.897959s20.897959 9.404082 20.89796 20.897959v156.734694c0 11.493878-9.404082 20.897959-20.89796 20.897959z" fill="#c23813" p-id="5260"></path><path d="M428.408163 709.485714c-11.493878 0-20.897959-9.404082-20.897959-20.897959v-156.734694c0-11.493878 9.404082-20.897959 20.897959-20.897959s20.897959 9.404082 20.897959 20.897959v156.734694c0 11.493878-9.404082 20.897959-20.897959 20.897959z" fill="#c23813" p-id="5261"></path></svg>
          <span v-if="account.bankInfo && account.bankInfo.bankAccount">*{{account.bankInfo.bankAccount.substr(-4)}}</span>
          <span>银行卡</span>
          <div class="svg">
            <svg t="1607484849593" class="icon" viewBox="0 0 1503 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6449" width="200" height="200"><path d="M433.191281 773.772335H989.244309c20.292532 0 36.744447-16.448112 36.744447-36.738743v-530.955921L433.191281 773.772335z m522.639652-215.384515l-124.1128 124.103294a13.373716 13.373716 0 0 1-19.014861 0l-18.99775-19.014862-62.911983-61.010687c-7.937911-7.93601-7.937911-20.672791 0-28.591689s20.672791-7.918898 28.59359 0l53.316143 51.414846a13.373716 13.373716 0 0 0 19.014861 0l95.502098-95.513506c7.937911-7.953121 20.672791-7.916997 28.610702 0.017112a20.148034 20.148034 0 0 1 0 28.595492z" p-id="6450" fill="#c23813"></path></svg>
          </div>
        </div>
      </div>
      <div class="list-item-box" v-if="withdrawTypes.withdrawLeshua==1"   @click="type='leshua'">
        <div class="list-item bank" :class="type=='leshua' ? 'active':''">
          <svg t="1675150538552" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5256" width="128" height="128"><path d="M846.367347 820.244898H177.632653c-45.97551 0-83.591837-37.616327-83.591837-83.591837V287.346939c0-45.97551 37.616327-83.591837 83.591837-83.591837h668.734694c45.97551 0 83.591837 37.616327 83.591837 83.591837v449.306122c0 45.97551-37.616327 83.591837-83.591837 83.591837zM177.632653 245.55102c-22.987755 0-41.795918 18.808163-41.795918 41.795919v449.306122c0 22.987755 18.808163 41.795918 41.795918 41.795919h668.734694c22.987755 0 41.795918-18.808163 41.795918-41.795919V287.346939c0-22.987755-18.808163-41.795918-41.795918-41.795919H177.632653z" fill="#c23813" p-id="5257"></path><path d="M114.938776 339.591837h794.122448v94.040816H114.938776z" fill="#c23813" p-id="5258"></path><path d="M219.428571 709.485714c-11.493878 0-20.897959-9.404082-20.897959-20.897959v-156.734694c0-11.493878 9.404082-20.897959 20.897959-20.897959s20.897959 9.404082 20.89796 20.897959v156.734694c0 11.493878-9.404082 20.897959-20.89796 20.897959z" fill="#c23813" p-id="5259"></path><path d="M323.918367 709.485714c-11.493878 0-20.897959-9.404082-20.897959-20.897959v-156.734694c0-11.493878 9.404082-20.897959 20.897959-20.897959s20.897959 9.404082 20.89796 20.897959v156.734694c0 11.493878-9.404082 20.897959-20.89796 20.897959z" fill="#c23813" p-id="5260"></path><path d="M428.408163 709.485714c-11.493878 0-20.897959-9.404082-20.897959-20.897959v-156.734694c0-11.493878 9.404082-20.897959 20.897959-20.897959s20.897959 9.404082 20.897959 20.897959v156.734694c0 11.493878-9.404082 20.897959-20.897959 20.897959z" fill="#c23813" p-id="5261"></path></svg>
          <span v-if="account.bankInfo && account.bankInfo.bankAccount">*{{account.bankInfo.bankAccount.substr(-4)}}</span>
          <span>银行卡</span>
          <div class="svg">
            <svg t="1607484849593" class="icon" viewBox="0 0 1503 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6449" width="200" height="200"><path d="M433.191281 773.772335H989.244309c20.292532 0 36.744447-16.448112 36.744447-36.738743v-530.955921L433.191281 773.772335z m522.639652-215.384515l-124.1128 124.103294a13.373716 13.373716 0 0 1-19.014861 0l-18.99775-19.014862-62.911983-61.010687c-7.937911-7.93601-7.937911-20.672791 0-28.591689s20.672791-7.918898 28.59359 0l53.316143 51.414846a13.373716 13.373716 0 0 0 19.014861 0l95.502098-95.513506c7.937911-7.953121 20.672791-7.916997 28.610702 0.017112a20.148034 20.148034 0 0 1 0 28.595492z" p-id="6450" fill="#c23813"></path></svg>
          </div>
        </div>
      </div>
    </div>
  <div v-if="money>0" class="showTrueMoney" style="padding: 10px 16px;font-size: 14px;color: #666;">实际到账 <strong style="color: #ff2e2e;">{{trueMoney}}</strong> 元</div>
    <div v-if="type=='bank'">
      <van-field
        v-model="bankInfo.username"
        name="开户名称"
        label="开户名称"
        required
        placeholder="一般为您的姓名"
      />
      <van-field
        v-model="bankInfo.certNo"
        name="身份证号"
        label="身份证号"
        required
        placeholder="身份证号"
      />
      <van-field
        v-model="bankInfo.mobile"
        name="手机号"
        label="手机号"
        required
        placeholder="手机号码"
      />
      <van-field
        v-model="bankInfo.bankName"
        name="银行名称"
        label="银行名称"
        required
        disabled
        @click="showBankPicker=true"
        placeholder="如：建设银行"

      />
      <van-field
        v-model="bankInfo.bankAccount"
        name="银行卡号"
        label="银行卡号"
        required
        placeholder="银行卡号"
      />
    </div>
    <div class="btn" @click="handleSubmit">
        <svg t="1607484070899" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4946" width="32" height="32"><path d="M179.849814 1010.862626 179.849814 1010.862626C106.485588 1010.862626 46.995821 951.372859 46.995821 878.009849L46.995821 147.319579C46.995821 73.951704 106.485588 14.461937 179.849814 14.461937l664.300372 0c73.363009 0 132.853993 59.489767 132.853993 132.857642l0 132.849128-66.431253 0L910.572925 147.31593c0-36.690019-29.73272-66.427605-66.421523-66.427605L179.853463 80.888325c-36.683937 0-66.431253 29.737586-66.431253 66.427605l0 730.689054c0 36.679072 29.737586 66.431253 66.431253 66.431253l664.291858 0c36.683937 0 66.426388-29.742451 66.426388-66.431253L910.571709 745.155856l66.426388 0 0 132.849128c0 73.367875-59.484902 132.857642-132.853993 132.857642L179.849814 1010.862626 179.849814 1010.862626 179.849814 1010.862626zM179.849814 1010.862626" p-id="4947" fill="#ffffff"></path><path d="M691.388832 331.130917c-12.942764-12.967091-12.942764-34.019 0-46.961765 12.975605-12.975605 34.023865-12.975605 47.004335 0L967.548578 513.320914c6.908646 6.913511 9.8582 16.088145 9.406949 25.128984 0.451251 9.05057-2.504384 18.230068-9.406949 25.17642L738.393168 792.778078c-12.98047 12.97074-34.028731 12.97074-47.004335 0-12.942764-12.975605-12.942764-34.028731 0-46.965414l174.156263-174.151397L609.008094 571.661267c-18.321291 0-33.21137-14.847507-33.21137-33.21137 0-18.316426 14.890078-33.21137 33.21137-33.21137l256.537001 0L691.388832 331.130917 691.388832 331.130917 691.388832 331.130917 691.388832 331.130917zM691.388832 331.130917" p-id="4948" fill="#ffffff"></path><path d="M297.104619 601.912136l0-50.382031L199.144154 551.530105c-20.554438 0-30.788478-7.435309-30.788478-22.392284 0-14.904674 10.23404-23.305734 30.788478-25.182501l67.176852 0L151.560855 327.619428c-1.881633 0-3.763266-1.839062-5.597463-5.597463-3.763266-5.601112-5.596247-13.032772-5.596247-22.392284 0-13.032772 8.399843-21.432615 25.191015-25.195881 13.031555 1.886498 24.226481 8.40106 33.585993 19.594769l128.752592 193.131929 128.748943-193.131929c7.440174-11.193709 18.633883-17.708271 33.590859-19.594769 14.909539 3.768131 23.309382 12.163109 25.18615 25.195881 0 5.597463-2.798731 13.075342-8.390113 22.392284-1.881633 1.881633-2.803597 3.758401-2.803597 5.597463L389.472487 503.95532l67.173203 0c18.633883 1.876768 28.910494 10.277827 30.792127 25.182501-1.881633 14.956975-12.158244 22.392284-30.792127 22.392284l-97.960465 0 0 50.377166 97.960465 0c18.633883 1.881633 28.910494 10.276611 30.792127 25.195881-1.881633 14.95211-12.158244 22.382554-30.792127 22.382554l-97.960465 0 0 111.962636c-1.881633 18.672805-12.163109 27.984882-30.788478 27.984882-20.558087 0-30.792127-9.312076-30.792127-27.984882L297.104619 649.485705 199.144154 649.485705c-20.554438 0-30.788478-7.430443-30.788478-22.382554 0-14.91927 10.23404-23.314248 30.788478-25.195881l97.960465 0L297.104619 601.912136 297.104619 601.912136zM297.104619 601.912136" p-id="4949" fill="#ffffff"></path></svg>
        <span>提现</span>
    </div>


    <van-popup v-model:show="showBankPicker" position="bottom" >
      <van-field
        v-model="searchKey"
        name="银行卡号"
        label="快速查找"
      />
      <van-picker
        title="请选择"
        show-toolbar
        :columns="bankSettingArr"
        @cancel="showBankPicker = false"
        @confirm="onConfirmBank"
      />
    </van-popup>

    <van-dialog
            v-model="mobileVerifyModal"
            :show-cancel-button="true"
            cancel-button-text="关闭"
            confirm-button-text="验证"
            :overlay="true"
            @confirm="handleVerify"
    >
        <div style="font-size: 13px;text-align: center;line-height: 40px;">为保证您的资金安全，请完成以下验证</div>
        <van-cell-group class="van-hairline--bottom">
            <van-field
                    v-model="verifyForm.mobile"
                    left-icon="phone-o"
                    type="number"
                    :placeholder="'请输入尾号'+this.mobileVerify.substr(-4,4)+'的号码'"
                    autocompleted="false"
            >
                <van-button slot="button" size="small" @click="sendVerifySms" v-if="codeSended == false"
                            type="info">获取验证码
                </van-button>
                <van-button slot="button" size="small" disabled v-else type="info">{{codeSendBtntext}}
                </van-button>
            </van-field>
        </van-cell-group>
        <van-cell-group>
            <van-field
                    v-model="verifyForm.code"
                    type="number"
                    left-icon="bag-o"
                    placeholder="请输入验证码"
                    autocompleted="false"
            />
        </van-cell-group>
    </van-dialog>


    <van-dialog
            v-model="showAliForm"
            :show-cancel-button="true"
            cancel-button-text="关闭"
            confirm-button-text="完善"
            :overlay="true"
            @confirm="handleCompleteAli"
    >
        <div style="font-size: 13px;text-align: center;line-height: 40px;">请先完善资料再提现</div>
        <van-cell-group class="van-hairline--bottom">
            <van-field
                    v-model="aliForm.account"
                    left-icon="phone-o"
                    type="text"
                    placeholder="支付宝账号(邮箱/手机)"
                    autocompleted="false"
            >
            </van-field>
        </van-cell-group>
        <van-cell-group>
            <van-field
                    v-model="aliForm.user"
                    type="text"
                    left-icon="user-o"
                    placeholder="请输入支付宝认证姓名"
                    autocompleted="false"
            />
        </van-cell-group>
    </van-dialog>
  <van-dialog
    v-model="showWechatForm"
    :show-cancel-button="true"
    cancel-button-text="关闭"
    confirm-button-text="完善"
    :overlay="true"
    @confirm="handleCompleteAli"
  >
    <div style="font-size: 13px;text-align: center;line-height: 40px;">请先完善资料再提现</div>
    <van-cell-group class="van-hairline--bottom">
      <van-field
        v-model="aliForm.truename"
        left-icon="user-o"
        type="text"
        placeholder="微信实名姓名"
        autocompleted="false"
      >
      </van-field>
    </van-cell-group>
    <p style="font-size: 11px;color: #ff2e2e;padding: 10px;">姓名与收款微信实名认证姓名不一致，会导致佣金无法到账!!</p>
  </van-dialog>

</div>
</template>

<script>
    import wx from "weixin-js-sdk"
    export default {
        name: "withdraw",
        data(){
            return {
                type:'',
                money:'',
              showBankPicker:false,
                commission:{},
                mobileVerify:'',
                mobileVerifyResult: false,
                verifyCode: '',
                verifyForm: {},
                codeSended: false,
                codeSendBtntext: '',
                mobileVerifyModal: false,
                account:{},
                showAliForm:false,
                aliForm:{},
                withdrawTypes:{},
                disabled:false,
                showWechatForm:false,
              bankInfo:{},
              bankSetting:[],
              searchKey:''
            }
        },
      computed:{
        bankSettingArr(){
          let arr = [];
          for(let i in this.bankSetting){
            if(this.searchKey && this.searchKey.length>1){
              if( this.bankSetting[i].indexOf(this.searchKey) !== -1) {
                arr.push({
                  text: this.bankSetting[i],
                  value: this.bankSetting[i],
                })
              }
            }else{
              arr.push({
                text:this.bankSetting[i],
                value:this.bankSetting[i],
              })
            }

          }

          return arr
        },
          trueMoney(){
            let feeLv = 0;
            switch (this.type) {
              case "wechat":
              case "wechatNew":
                if(this.withdrawTypes.withdrawFeeWechat > 0) {
                  feeLv = this.withdrawTypes.withdrawFeeWechat / 100;
                }
                break;
              case "alipay":
                if(this.withdrawTypes.withdrawFeeAlipay > 0) {
                  feeLv = this.withdrawTypes.withdrawFeeAlipay / 100;
                }
                break;
              case "bank":
                if(this.withdrawTypes.withdrawFeeBank > 0) {
                  feeLv = this.withdrawTypes.withdrawFeeBank/100;
                }
                break;
              case "leshua":
                if(this.withdrawTypes.withdrawFeeLeshua > 0) {
                  feeLv = this.withdrawTypes.withdrawFeeLeshua/100;
                }
                break;
            }
            return this.money - this.money * feeLv
          }
      },
        created:function () {

            this.getCommission();
            this.getMobileVerify()
            this.getAccount();
            this.getWithdrawTypes();
            this.getAuthInfo();
            this.fetchData("/config/bank",{},res=>{
              this.bankSetting = res.data
            })
        },
      mounted() {
        this.initWechatJs()
      },
      methods:{
            initWechatJs(){
              let url = encodeURIComponent(location.href.split('#')[0])
              this.fetchData('/base/jssdk',{url:url},(res)=>{
                if(res.code){
                  wx.config(res.data);
                  wx.ready(()=>{
                    this.getLocation()
                  })
                }
              })
            },
            onClickLeft(){
                window.history.go(-1)
            },
            getLocation(){
              wx.getLocation({
                type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
                success: (locationInfo) =>{
                  let latitude = locationInfo.latitude; // 纬度，浮点数，范围为90 ~ -90
                  let longitude = locationInfo.longitude; // 经度，浮点数，范围为180 ~ -180。
                  this.fetchData('/account/setLat',locationInfo,res=>{

                  })
                },
                cancel:()=>{
                  this.$dialog.alert({
                    title: '提示',
                    message: '请允许获取位置',
                  }).then(() => {
                    this.getLocation()
                  });
                }
              });
            },
            getAuthInfo(){
                this.fetchData('/login/getAuthInfo', '', (res) => {
                    if (!res.code) {
                        this.$dialog.alert({
                            title: '提示',
                            message: res.msg,
                        }).then(() => {
                            window.location.href = res.url
                        });
                    }
                })
            },
          onConfirmBank(item){
              this.bankInfo.bankName = item.value
              this.showBankPicker = false
          },
            getAccount() {
                this.fetchData('/account/info', '', (res) => {
                    if (res.code) {
                        this.account = res.data


                        if(this.account.openid==''){
                            this.$dialog.confirm({
                                title: '提示',
                                message: "未绑定微信，无法提现，点击确定进行绑定",
                            }).then(() => {
                                this.$toast.loading()
                                this.fetchData('/config/bindwx', '', (res) => {
                                    this.$toast.clear()
                                    if (res.code) {
                                        window.location.href = res.data
                                    }else{
                                        this.$toast("绑定链接获取失败")
                                    }
                                })
                            });
                            return  false
                        }

                          this.bankInfo = this.account.bank_info
                        if(this.bankInfo .needAddress && (!this.bankInfo || !this.bankInfo.address ||  !this.bankInfo.city)){
                          this.$dialog.alert({message:"请先完善收货地址"}).then(()=>{
                            this.$router.push({name:"bankInfo",query:{scope:["address","username","mobile"]}})
                          })
                        }
                    }
                })
            },
            getWithdrawTypes(){
                this.fetchData('/withdraw/withdrawType', '', (res) => {
                    if (res.code) {
                        this.withdrawTypes = res.data
                        if(this.withdrawTypes.withdrawAli == 1){
                            this.type = 'alipay'
                        }
                        if(this.withdrawTypes.withdrawWechat== 1){
                            this.type = 'wechat'
                        }
                        if(this.withdrawTypes.withdrawWechatNew== 1){
                            this.type = 'wechatNew'
                        }
                      if(this.withdrawTypes.withdrawBank== 1){
                        this.type = 'bank'
                      }
                      if(this.withdrawTypes.withdrawLeshua== 1){
                        this.type = 'leshua'
                      }
                    }
                })
            },
            confirmMerchantTransfer(data){
              if (!data || !data.package) {
                this.$toast('确认收款参数缺失，请稍后重试或联系客服')
                return
              }
              const doInvoke = () => {
                // eslint-disable-next-line no-undef
                WeixinJSBridge.invoke('requestMerchantTransfer', {
                  mchId: String(data.mchId),
                  appId: String(data.appId),
                  package: data.package,
                }, (res) => {
                  if (res.err_msg === 'requestMerchantTransfer:ok') {
                    this.$toast.success('已提交确认，请等待到账')
                    this.$router.go(-1)
                  } else {
                    this.$toast('未完成确认，可稍后在首页继续确认')
                    this.disabled = false
                  }
                })
              }
              // eslint-disable-next-line no-undef
              if (typeof WeixinJSBridge === 'undefined') {
                document.addEventListener('WeixinJSBridgeReady', doInvoke, false)
              } else {
                doInvoke()
              }
            },
            getCommission() {
                this.fetchData('/account/commission', '', (res) => {
                    if (res.code) {
                        this.commission = res.data
                    }
                })
            },
            getMobileVerify() {
                this.fetchData('/withdraw/mobileVerifyConfig', '', (res) => {
                    if (res.code) {
                        this.mobileVerify = res.data
                    }
                })
            },
            handleSubmit(){
                if(!this.money){
                    this.$toast.fail("请输入提现金额")
                    return false
                }
                if(!this.type){
                    this.$toast.fail("请选择提现方式")
                    return false
                }
                if(!this.money > this.commission.remain){
                    this.$toast.fail("余额不足")
                    return false
                }
                if (this.mobileVerify != false && this.mobileVerifyResult == false) {
                    this.mobileVerifyModal = true
                } else {
                    this.handleWithdraw()
                }
            },
            sendVerifySms() {
                if (this.verifyForm.mobile != this.mobileVerify) {
                    this.$toast.fail("请准确输入账号绑定的手机号码")
                    return false
                }
                if (this.codeSended == true) return false
                this.$toast.loading("发送中")
                this.fetchData("/sms/sendVerifyOperatorCode", {mobile: this.verifyForm.mobile}, (res) => {
                    this.$toast.loading().clear()
                    if (res.code) {
                        this.codeSended = true
                        let i = 60
                        let intval = setInterval(() => {
                            if (i <= 0) {
                                clearInterval(intval)
                                this.codeSended = false
                                this.codeSendBtntext = "获取验证码"
                            } else {
                                this.codeSendBtntext = "( " + i + "s )"
                                i--
                            }
                        }, 1000)
                        this.$toast.success(res.msg)
                    } else {
                        this.$toast.fail(res.msg)
                    }
                })
            },
            handleWithdraw() {
                if(this.type == 'alipay' && (this.account.aliUser=='' || this.account.aliAccount=='')){
                    this.showAliForm = true;
                    return false;
                }
              if((this.type == 'wechat' || this.type == 'wechatNew') && (this.account.truename=='')){
                this.showWechatForm = true;
                return false;
              }
              if(this.type == 'bank' && (
                !this.bankInfo.username ||
                !this.bankInfo.mobile ||
                !this.bankInfo.certNo ||
                !this.bankInfo.bankName || !this.bankInfo.bankAccount
              )){
                this.$toast("请完整填写银行信息")
                return false;
              }
              if(this.type == 'leshua' && (
                !this.bankInfo.agentSn
              )){
                this.$toast("请完整填写银行信息")
                this.$router.push({name:'leshuaInfo'})
                return false;
              }


                if(this.disabled) return  false
                this.disabled = true
                this.$toast.loading("提交中")
                this.fetchDataPost('/withdraw/withdraw', {
                    money: this.money,
                    code: this.verifyForm.code,
                    type:this.type,
                    bankInfo:this.bankInfo
                }, (res) => {
                    this.$toast.clear()
                    if (res.code) {
                        this.disabled = false
                        if (res.data && res.data.needConfirm) {
                          this.$toast(res.msg || '请确认收款')
                          this.confirmMerchantTransfer(res.data)
                          return
                        }
                        this.$router.go(-1)
                        this.$toast.success(res.msg)
                    } else {
                      if(res.data && res.data.redirect){
                        this.$dialog.alert({message:res.msg}).then(()=>{
                          this.$router.push({name:res.data.redirect})
                        })

                      }else {
                        this.disabled = false
                        this.$toast(res.msg)
                      }
                    }
                })
            },
            handleCompleteAli(){
                this.fetchData("/account/completeAli", this.aliForm, (res) => {
                    if (res.code) {
                        this.showAliForm = false
                        this.$toast.success(res.msg)
                        this.getAccount()
                    } else {
                        this.$toast.fail(res.msg)
                    }
                })
            },
            handleVerify() {
                this.fetchData("/sms/verifyOperator", {code: this.verifyForm.code}, (res) => {
                    if (res.code) {
                        this.mobileVerifyModal = false
                        this.mobileVerifyResult = true
                        this.handleWithdraw()
                    } else {
                        this.$toast.fail(res.msg)
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .svg svg,.svn path{
        width: 42px;
        height: 42px;
        position: absolute;
        right: -0.2rem;
        bottom: -0.2rem;
    }
    .title{
        margin-top: 1rem;
        font-size: 18px;
        text-align: center;
        color: #060606;
    }
    .input{
        border-top: none;
        border-left: none;
        border-right: none;
        border-bottom: 1px solid #000;
        width: 6rem;
        display: block;
        margin: .2rem auto;
        font-size: 16px;
        font-weight: bolder;
        padding: .2rem .1rem;
        text-align: center;
    }
    .money{
        font-size: 22px;
        font-weight: bolder;
        line-height: 1rem;
        text-align: center;
    }
    .type{
        margin: .3rem 0 0 .4rem;
        font-size: 14px;
    }
    .list{
        margin-top: .1rem;
        text-align: center;
        display: flex;
    }
    .list-item-box{
      flex: 1;
      padding: .1rem;
    }
    .list-item{
        position: relative;
        display: block;
        height: 36px;
        font-size: 13px;
        border: 1px solid #eee;
        line-height: 36px;
        padding: .2rem;
        box-shadow: 1px 1px 1px #eee;
    }
    .list-item .svg{
        display: none;
    }
    .wechat.active{
        border: 1px solid #5daf34;
        color: #5daf34;
    }

    .bank.active{
      border: 1px solid #c23813;
      color: #c23813;
    }

    .alipay.active{
        color: #3a8ee6;
        border: 1px solid #3a8ee6;
    }
    .list-item.active .svg{
        display: block;
    }
    .list-item span{
        line-height: 36px;
    }
    .list-item path,.list-item svg{
        width: 36px;
        height: 36px;
        float: left;
        display: inline-block;

    }
    .btn{
        width: 7rem;
        height: 40px;
        margin: 1rem auto;
        background: #3a8ee6;
        color: #fff;
        text-align: center;
        font-size: 16px;

        border-radius: 5px;
    }
    .btn svg,.btn path{
        width: 16px;
        height: 16px;
        margin-top: 12px;
        display: inline-block;
    }
    .btn svg,.btn path:after{
        clear: both;
    }
    .btn span{
        display: inline-block;
        line-height: 40px;
        vertical-align: top;
    }
    ::-webkit-input-placeholder { /* WebKit browsers */
        color: #999;
        font-size: 16px;
        font-weight: normal;
    }

    ::-moz-placeholder { /* Mozilla Firefox 19+ */
        color: #999;
        font-size: 16px;
        font-weight: normal;
    }

    :-ms-input-placeholder { /* Internet Explorer 10+ */
        color: #999;
        font-size: 16px;
        font-weight: normal;
    }
</style>



// WEBPACK FOOTER //
// src/pages/withdraw.vue